import { useState, useEffect } from "react";
import { ThemingParameters } from "@ui5/webcomponents-react-base";
import "@ui5/webcomponents/dist/Assets.js";
import "@ui5/webcomponents-fiori/dist/Assets.js";
import refresh from "@ui5/webcomponents-icons/dist/refresh";
import {
  FlexBox,
  FlexBoxAlignItems,
  FlexBoxDirection,
  FlexBoxJustifyContent,
  Label,
  Card,
  CardHeader,
  Text,
  Panel,
  Grid,
  Table,
  TableColumn,
  TableRow,
  TableCell,
  Title,
  Button,
  Select,
  Option,
  BusyIndicator,
  Slider,
  Switch,
  Loader,
} from "@ui5/webcomponents-react";
import { EstSlider } from "./components/EstSlider";
import { EstInfoButton } from "./components/EstInfoButton";
import { EstOutputLine } from "./components/EstOutputLine";
import { spacing } from "@ui5/webcomponents-react-base";
import { ColumnChart, LineChart } from "@ui5/webcomponents-react-charts";
import "./App.css";
import { startCalcXPercent } from "./calcModuleXPercent";
import { startCalcDynamic } from "./calcModuleDynamic";
import {
  yearFormatter,
  percentFormatter,
  currencyFormatter,
} from "./scrpits/formatters";
import { getAverageRate } from "./scrpits/calcHelper";
import { loadConfig } from "./scrpits/utils";

export  function Main() {
    const [constants, setConstants] = useState({});
  const [inputData, setInputData] = useState({
    savings: 50000,
    years: 30,
    withdrawalRate: 0.05,
    riskPortionRate: 0.6,
    periodLength: 1,
    maxWithdrawal: 10000,
    inflationrate: 0,
    useMaxWithdrawal: false,
    adjustInflation: false
  });

  const [results, setResults] = useState({
    simulationResults: {},
    brokeProbability: 0,
    brokeCounter: 0,
    avgBrokeYear: 0,
    endSavings: {
      avgEndSavingsReal: 0,
      endSavingsQ5: 0,
      endSavingsQ25: 0,
      endSavingsQ50: 0,
      endSavingsQ75: 0,
      endSavingsQ95: 0,
      endSavingsNoneBroke: [],
    },
    histData: {},
    rows: {},
    inputData: {
      savings: 0,
      years: 0,
      withdrawalRate: 0,
      riskPortionRate: 0,
      periodLength: 0,
      maxWithdrawal: 0,
    },
  });
  const [outputPanelCollapsed, setOutputPanelCollapsed] = useState(true);
  const [showResults, setShowResults] = useState(false);
  const [busy, setBusy] = useState(false);
  const [useMaxWithdrawal, setuseMaxWithdrawal] = useState(false);
  const [adjustInflation, setAdjustInflation] = useState(false);
  const [averageRate, setAverageRate] = useState(0);



  const [selectedRule, setSelectedRule] = useState("1");

  const ruleSelectData = [
    { id: "1", text: "X%-Entnahme" },
    { id: "2", text: "Dynamische-Entnahme" },
  ];

  const onChangeSelect = async (event) => {
    // event.detail.selectedOption is a reference to the selected HTML Element
    // dataset contains all attributes that were passed with the data- prefix.
    setSelectedRule(event.detail.selectedOption.dataset.id);
    setOutputPanelCollapsed(true);
    setShowResults(false);
    if (averageRate === 0){
    setAverageRate(await getAverageRate());
    // setConstants(await loadConfig());
  }
  };

  const setInputProperty = (event, prop) => {
    setInputData({ ...inputData, [prop]: event.target.value });
  };

  const createRows = (data) => {
    return data.map((x, index) => (
      <TableRow key={`${index + 1}-row`}>
        <TableCell>
          <Label>{index + 1}</Label>
        </TableCell>
        <TableCell>
          <Label>{currencyFormatter(x)}</Label>
        </TableCell>
      </TableRow>
    ));
  };

  const onChangeSwitchMaxWithdrawal = async (event) => {
    let newValue = !useMaxWithdrawal;

    setuseMaxWithdrawal(newValue);
    setInputData({ ...inputData, useMaxWithdrawal: newValue });
  };
  const onChangeSwitchInflation = async (event) => {
    let newValue = !adjustInflation;
    setAdjustInflation(newValue);
    setInputData({ ...inputData, adjustInflation: newValue, inflationrate: constants.inflationrate });
    // setInputData({ ...inputData, inflationrate: constants.inflationrate });
  };

  const [randomConsumeIndex, setRandomConsumeIndex] = useState(0);

  const onRandomConsumeClick = () => {
    setRandomConsumeIndex(Math.floor(Math.random() * results.withdrawal.realWithdrawalsChartData.length))
  };


const onStartCalc = () => {
  setOutputPanelCollapsed(true);
  setShowResults(false);
  setBusy(true);
};

useEffect( () => {
  if (busy) {
  
    async function fetchData() {  
      let simResults = {};

      // start calculation and receive results
      if (selectedRule === "1") {
        simResults = await startCalcXPercent(inputData);
      } else {
        simResults = await startCalcDynamic(inputData);
      }

      if (selectedRule === "1") {
        setResults({
          ...results,
          inputData: inputData,
          brokeProbability: simResults.brokeProbability,
          endSavingsNoneBroke: simResults.endSavings,
          endSavings: simResults.endSavings,
          avgBrokeYear: simResults.avgBrokeYear,
          histData: simResults.histData,
        });
      } else {
        setResults({
          ...results,
          inputData: inputData,
          avgRealWithdrawal: simResults.avgRealWithdrawal,
          histData: simResults.histData,
          withdrawal: simResults.withdrawal,
          rows: createRows(simResults.withdrawal.realWithdrawalAvgByPeriod),
        });
      }
      setBusy(false);
      setShowResults(true);
      setOutputPanelCollapsed(false);
    } 
    setTimeout(() => {
    fetchData() },100);
   

  }

}, [busy, showResults, inputData, results, selectedRule, outputPanelCollapsed]);

useEffect( () => {
async function laodCon() {
  let c = await loadConfig();
  setConstants(c);
  setInputData({ ...inputData, inflationrate: c.inflationrate });
 }
 setTimeout(() => {
   laodCon() },100);
},[])

  return (
    <>
    
      <Grid
        style={{
          backgroundColor: ThemingParameters.sapBackgroundColor,
        }}
      >
        <Panel
          data-layout-indent="XL3 L2 M2 S0"
          data-layout-span="XL6 L8 M8 S12"
          headerText="Input"
          style={{
            backgroundColor: ThemingParameters.sapBaseColor,
          }}
        >
          <FlexBox alignItems="Start" direction="Row">
            <Title wrappingType="Normal" level="H5" style={{ textAlign: "start" }} icon="information">
              Entsparstrategie
            </Title>
            <EstInfoButton
              header="Entsparstrategie"
              text={
                "X%-Entnahme: \n\n Diese Strategie hat das Ziel einen konstanten Konsum über den Planungshorizont zu ermöglichen. \n Die Regel ist nicht kompliziert: Am Anfang jeder Periode (z.B. jedes Jahres) wird ein konstanter realer (also Inflationsadjustierter) Betrag aus dem Portfolio entnommen. Durch die Inflation müssen wir jede Periode ein wenig mehr entnehmen, damit unsere Konsummöglichkeiten auch wirklich konstant bleiben. \n \n Beispiel: Wenn Sie 500.000 Euro über 20 Jahre entsparen möchten und in der Simulation die Entnahme auf 5% stellen, dann bedeutet das, dass Sie im ersten Jahr 25.000 Euro entnehmen und diesen Betrag jedes Jahr um die Inflationsrate (1,5%) steigern. Im zweiten Jahr also 25.000 x 1,015 = 25.375 Euro. Im dritten Jahr 25.755,63 Euro und so weiter. \n\n\n Dynamische-Entnahme: \n\n Diese Strategie hat die Ziele, dass das Vermögen zum einen über den gesamten Planungshorizont ausreicht und zum anderen am Ende des Planungshorizonts auch wirklich aufgebraucht ist. Diese Ziele können durch eine dynamische Anpassung der Entnahme erreicht werden. Einfach ausgedrückt: läuft der Kapitalmarkt gut entnehme ich mehr, läuft er schlecht entnehme ich weniger. Der Konsum wird also nicht in jeder Periode gleich sein, sondern schwanken. Wer möchte kann diese Schwankungen etwas reduzieren, indem eine Obergrenze für den Konsum festgelegt wird. Läuft der Kapitalmarkt super, entnehmen wir mit Obergrenze trotzdem ein bisschen weniger als wir könnten und behalten den Rest für Zeiten in denen der Kapitalmarkt nicht so gut läuft. Stellen Sie im Simulator einfach mal verschiedene Obergrenzen ein und schauen, wie diese Sich auf den Konsum und dessen Schwankung auswirken."
              }
              iconId="StrategieInfo-icon"
              iconStyle={{ ...spacing.sapUiSmallMarginBegin }}
            ></EstInfoButton>
          </FlexBox>

          <FlexBox
            alignItems="Start"
            direction="Row"
            justifyContent="Start"
            wrap="NoWrap"
            style={{ ...spacing.sapUiContentPadding }}
          >
            <Select onChange={onChangeSelect}>
              {ruleSelectData.map((item) => (
                <Option key={item.id} data-id={item.id}>
                  {item.text}
                </Option>
              ))}
            </Select>
          </FlexBox>

          <EstSlider
            title="Entsparvermögen"
            value={inputData.savings}
            formatter={currencyFormatter}
            sliderProps={{
              value: inputData.savings,
              min: 10000,
              max: 1000000,
              step: 10000,
              onChange: (e) => setInputProperty(e, "savings"),
              onInput: (e) => setInputProperty(e, "savings"),
            }}
            id="savingsSlider"
            infoText={
              "Vermögen, das Sie entsparen möchten. \n \n Beispiel: \n Sie haben 750.000 Euro Vermögen, möchten davon 250.000 vererben \n und den Rest entsparen, dann stellen Sie den Regler auf 500.000."
            }
          ></EstSlider>
          <EstSlider
            title="Planungshorizont"
            value={inputData.years}
            formatter={yearFormatter}
            sliderProps={{
              value: inputData.years,
              min: 5,
              max: 50,
              step: 1,
              onChange: (e) => setInputProperty(e, "years"),
              onInput: (e) => setInputProperty(e, "years"),
            }}
            id="yearsSlider"
            infoText={
              "Zeitraum in Jahren über den das Vermögen entspart (verbraucht) werden soll."
            }
          ></EstSlider>
          {selectedRule === "1" && (
            <EstSlider
              title="Jährliche Entnahme"
              value={
                currencyFormatter(
                  inputData.withdrawalRate * inputData.savings
                ) +
                " (" +
                percentFormatter(inputData.withdrawalRate, 1) +
                ")"
              }
              sliderProps={{
                value: inputData.withdrawalRate,
                min: 0.01,
                max: 0.25,
                step: 0.005,
                onChange: (e) => setInputProperty(e, "withdrawalRate"),
                onInput: (e) => setInputProperty(e, "withdrawalRate"),
              }}
              id="withdrawalRateSlider"
              infoText={
                "Stellen Sie hier den Betrag / Prozentsatz ein, \n den Sie real (inflationsadjustiert) jedes Jahr entsparen möchten."
              }
            ></EstSlider>
          )}
          <EstSlider
            title="Vermögensaufteilung (Anteil riskante Anlagemöglichkeit)"
            value={percentFormatter(inputData.riskPortionRate,0)}
            sliderProps={{
              value: inputData.riskPortionRate,
              min: 0,
              max: 1,
              step: 0.05,
              onChange: (e) => setInputProperty(e, "riskPortionRate"),
              onInput: (e) => setInputProperty(e, "riskPortionRate"),
            }}
            id="riskPortionRateSlider"
            infoText={
              "Stellen Sie hier die Aufteilung in riskante Kapitalmarktanlage und risikofreie Anlage ein. \n \n Der Regler zeigt den Anteil, welcher in die riskante Kapitalmarktanlage (60/40 Portfolio) \n investiert wird. Der Rest wird risikofrei zu 3% Nominalzins angelegt. "
            }
          ></EstSlider>
           {selectedRule === '2' &&
                        <EstSlider title="Entnahmeinterval" value={yearFormatter(inputData.periodLength)} sliderProps={{ value: inputData.periodLength, min: 1, max: 10, step: 1, showTickmarks: true, onChange: (e) => setInputProperty(e, "periodLength"), onInput: (e) => setInputProperty(e, "periodLength") }} id="periodLengthSlider" infoText={"Stellen Sie hier ein, für welchen Zeitraum Sie Kapital aus dem \n Portfolio entnehmen möchten. \n \n Ein Entnahmeinterval von 1 Jahr bedeutet, dass Sie am Anfang \n jeden Jahres die jährliche Entnahme tätigen. \n Ein Entnahmeinterval von 2 Jahren bedeutet, dass Sie alle zwei \n Jahre den doppelten realen Betrag entnehmen, usw."}></EstSlider>
                    } 
          {selectedRule === "2" && (
            <>
              <FlexBox
                alignItems="Start"
                direction="Row"
                justifyContent="SpaceBetween"
                wrap="NoWrap"
              >
                <FlexBox
                  alignItems="Center"
                  direction="Row"
                  style={{ width: "66%" }}
                >
                  <Title wrappingType="Normal"
                    level="H5"
                    style={{ textAlign: "start" }}
                    icon="information"
                  >
                    Konsum-Obegrenze pro Periode
                  </Title>

                  <EstInfoButton
                    header="Konsum Obegrenze pro Periode"
                    text={"Realer Konsum Obergrenze pro Periode \n (Hinweis: Erwarteter realer Konsum pro Periode = " + 
                    currencyFormatter(
                      (((1 +  (averageRate * inputData.riskPortionRate +
                        constants.risklessRate * (1 - inputData.riskPortionRate) )) **
                      (inputData.years  - 1) *
                      ( (averageRate * inputData.riskPortionRate +
                        constants.risklessRate * (1 - inputData.riskPortionRate) ) - inputData.inflationrate)) /
                    ((1 +  (averageRate * inputData.riskPortionRate +
                      constants.risklessRate * (1 - inputData.riskPortionRate) )) **
                      (inputData.years) -
                      (1 + inputData.inflationrate) **
                        (inputData.years)))*inputData.savings
                      ) + "  )"  }
                    iconId="infoMaxWithdrawal"
                    iconStyle={{ ...spacing.sapUiSmallMarginBegin }}
                  ></EstInfoButton>
                  <Switch
                    textOn="An"
                    textOff="Aus"
                    checked={useMaxWithdrawal}
                    onChange={onChangeSwitchMaxWithdrawal}
                    style={{ ...spacing.sapUiSmallMarginBegin }}
                  ></Switch>
                </FlexBox>
                {useMaxWithdrawal === true && (
                  <Title wrappingType="Normal"
                    level="H5"
                    style={{ alignItems: "end", textAlign: "end" }}
                  >
                    {currencyFormatter(inputData.maxWithdrawal) 
                    }
                  </Title>
                )}
              </FlexBox>
              
                <Slider
                  disabled={!useMaxWithdrawal}
                  value={inputData.maxWithdrawal}
                  min={1000}
                  max={inputData.savings/5}
                  step={1000}
                  onChange={(e) => setInputProperty(e, "maxWithdrawal")}
                  onInput={(e) => setInputProperty(e, "maxWithdrawal")}
                ></Slider>
            </>
          )}
             <FlexBox
                alignItems="Start"
                direction="Row"
                justifyContent="SpaceBetween"
                wrap="NoWrap"
              >
              <FlexBox
                  alignItems="Center"
                  direction="Row"
                  style={{ width: "66%" }}
                >
                  <Title wrappingType="Normal"
                    level="H5"
                    style={{ textAlign: "start" }}
                    icon="information"
                  >
                    Jährliche Inflationsrate anpassen
                  </Title>

                  <EstInfoButton
                    header="Jährliche Inflationsrate"
                    text={"Hinweis: Das Inflationsziel der EZB beträgt 2%"}
                    iconId="infoInflation"
                    iconStyle={{ ...spacing.sapUiSmallMarginBegin }}
                  ></EstInfoButton>
              <Switch
                    textOn="An"
                    textOff="Aus"
                    checked={adjustInflation}
                    onChange={onChangeSwitchInflation}
                    style={{ ...spacing.sapUiSmallMarginBegin }}
                  ></Switch>
                </FlexBox>
              
                  <Title wrappingType="Normal"
                    level="H5"
                    style={ !adjustInflation ? { alignItems: "end", textAlign: "end", color:ThemingParameters.sapContent_DisabledTextColor } : { alignItems: "end", textAlign: "end"}}
                  >
                    {percentFormatter(inputData.inflationrate) 
                    }
                  </Title>
              </FlexBox>
                <Slider
                  disabled={!adjustInflation}
                  value={inputData.inflationrate}
                  min={0}
                  max={0.1}
                  step={0.005}
                  onChange={(e) => setInputProperty(e, "inflationrate")}
                  onInput={(e) => setInputProperty(e, "inflationrate")}
                  showTickmarks="false"
                ></Slider>
        

          <br />
          <br />
          <FlexBox
            style={{ width: "100%" }}
            direction={FlexBoxDirection.Column}
            alignItems={FlexBoxAlignItems.Center}
          >
            <Button style={{ width: "40%" }} onClick={onStartCalc} disabled={busy}>
            {busy ? "Simulation läuft"
                            : "Simulation starten"} 
            </Button> 
          </FlexBox>
        </Panel>
      </Grid>

      <Grid
        style={{
          backgroundColor: ThemingParameters.sapBackgroundColor,

        }}
      >
        
        <Panel
          data-layout-indent="XL3 L2 M2 S0"
          data-layout-span="XL6 L8 M8 S12"
          headerText="Output"
          id="outputPanel"
          style={{
            backgroundColor: ThemingParameters.sapBaseColor,
          }}
          collapsed={outputPanelCollapsed}
          onToggle={(event) => setOutputPanelCollapsed(!outputPanelCollapsed)}
        >

          
          {showResults && (
            <FlexBox
              style={{ width: "100%" }}
              direction={FlexBoxDirection.Column}
              justifyContent={FlexBoxJustifyContent.Center}
              alignItems={FlexBoxAlignItems.Center}
            >
              <Card
                header={<CardHeader titleText="Eingaben" />}
                style={{ ...spacing.sapUiContentPadding }}
              >
                <Text style={{ width: "66%", ...spacing.sapUiContentPadding }}>
                  Entsparstrategie
                </Text>
                <Text style={{ width: "34%", ...spacing.sapUiContentPadding }}>
                  {ruleSelectData.filter((x) => x.id === selectedRule)[0].text}
                </Text>
                <Text style={{ width: "66%", ...spacing.sapUiContentPadding }}>
                  Entsparvermögen
                </Text>
                <Text style={{ width: "34%", ...spacing.sapUiContentPadding }}>
                  {currencyFormatter(results.inputData.savings)}
                </Text>
                <Text style={{ width: "66%", ...spacing.sapUiContentPadding }}>
                  Planungshorizont
                </Text>
                <Text style={{ width: "34%", ...spacing.sapUiContentPadding }}>
                  {yearFormatter(results.inputData.years)}
                </Text>
                {selectedRule === "1" && (
                  <>
                    <Text
                      style={{ width: "66%", ...spacing.sapUiContentPadding }}
                    >
                      Jährliche Entnahme
                    </Text>
                    <Text
                      style={{ width: "34%", ...spacing.sapUiContentPadding }}
                    >
                      {currencyFormatter(
                        inputData.withdrawalRate * inputData.savings
                      )}
                    </Text>
                  </>
                )}
                <Text style={{ width: "66%", ...spacing.sapUiContentPadding }}>
                  Vermögensaufteilung (Anteil riskante Anlagemöglichkeit)
                </Text>
                <Text style={{ width: "34%", ...spacing.sapUiContentPadding }}>
                  {percentFormatter(results.inputData.riskPortionRate,0)}
                </Text>
                {selectedRule === "2" && (
                  <>
                    <Text
                      style={{ width: "66%", ...spacing.sapUiContentPadding }}
                    >
                      Entnahmeinterval
                    </Text>
                    <Text
                      style={{ width: "34%", ...spacing.sapUiContentPadding }}
                    >
                      {yearFormatter(results.inputData.periodLength)}
                    </Text>
                  </>
                )}

                {selectedRule === "2" && (
                  <>
                    <Text
                      style={{ width: "66%", ...spacing.sapUiContentPadding }}
                    >
                      Konsum-Obergrenze pro Periode
                    </Text>
                    <Text
                      style={{ width: "34%", ...spacing.sapUiContentPadding }}
                    >
                      { results.inputData.useMaxWithdrawal ? currencyFormatter(results.inputData.maxWithdrawal) : "-" }
                    </Text>
                  </>
                )}
                 <Text
                      style={{ width: "66%", ...spacing.sapUiContentPadding }}
                    >
                      Jährliche Inflationsrate
                    </Text>
                    <Text
                      style={{ width: "34%", ...spacing.sapUiContentPadding }}
                    >
                      { percentFormatter(results.inputData.inflationrate) } 
                    </Text>
              </Card>

              <Card
                header={<CardHeader titleText="Ergebnisse" />}
                style={{ ...spacing.sapUiContentPadding }}
              >
                {selectedRule === "1" && (
                  <>
                    <EstOutputLine
                      title="Ø Konsum p.a."
                      value={currencyFormatter(
                        results.inputData.savings *
                          results.inputData.withdrawalRate
                      )}
                      id="infoKonsum"
                      infoText={
                        "Durchscnittlicher Konsum pro Periode \n (entspricht bei der x%-Entnahme der jährlichen Entnahmen). "
                      }
                    ></EstOutputLine>
                    <EstOutputLine
                      title="Pleitewahrscheinlichkeit"
                      value={percentFormatter(results.brokeProbability,1)}
                      id="infoPleiteWahrscheinlichkeit"
                      infoText={
                        "In wie viel Prozent der Fälle kam es zur Pleite vor Erreichen des Planungshorizonts."
                      }
                    ></EstOutputLine>
                    <EstOutputLine
                      title="Durchschnittliche Pleiteperiode"
                      value={results.avgBrokeYear ? yearFormatter(results.avgBrokeYear) : "-"}
                      id="infoPleiteperiode"
                      infoText={
                        "Wie lange hat das Kapital gereicht, \n wenn es zur Pleite vor Erreichen des Planungshorizonts kam."
                      }
                    ></EstOutputLine>
                    <EstOutputLine
                      title="Durchschnittliches Endvermögen (ohne Pleitefälle)"
                      value={currencyFormatter(
                        results.endSavingsNoneBroke.avgEndSavingsReal
                      )}
                      id="infoEndvermögen"
                      infoText={
                        "Durchschnittliches Endvermögen ohne Fälle in denen es zur Pleite kam"
                      }
                    ></EstOutputLine>

                    <Text
                      style={{ width: "66%", ...spacing.sapUiContentPadding }}
                    >
                      Verteilung des realen Endvermögens in EUR (ohne
                      Pleitefälle):
                    </Text>
                  </>
                )}
                {selectedRule === "2" && (
                  <>
                    <EstOutputLine
                      title="Ø Konsum p.a."
                      value={currencyFormatter(results.avgRealWithdrawal)}
                      id="infoKonsum2"
                      infoText={"Durchscnittlicher Konsum pro Periode."}
                    ></EstOutputLine>
                    <EstOutputLine
                      title="Schwankung des Konsums"
                      value={currencyFormatter(
                        results.withdrawal.realWithdrawalsStandardDeviation
                      )}
                      id="infoKonsumSchwankung"
                      infoText={"Standardabweichung des jährlichen Konsums. \n \n In 75% der Fällen liegt der Konsum zwischen " + currencyFormatter(results.withdrawal.realWithdrawalsQ12_5) + " und "  + currencyFormatter(results.withdrawal.realWithdrawalsQ87_5) + ".\n \n In 90% der Fällen liegt der Konsum zwischen " + currencyFormatter(results.withdrawal.realWithdrawalsQ5) + " und "  + currencyFormatter(results.withdrawal.realWithdrawalsQ95) + "."}
                    ></EstOutputLine>
                    {/* <EstOutputLine
                      title="Beste Periode"
                      value={currencyFormatter(
                        results.withdrawal.realWithdrawalMax
                      )}
                      id="infoBestePeriode"
                      infoText={
                        "Periode mit der höchsten Entnahme (abhängig von der Konsom Obergrenze)."
                      }
                    ></EstOutputLine> */}
                    {/* <EstOutputLine
                      title="Schlechteste Periode"
                      value={currencyFormatter(
                        results.withdrawal.realWithdrawalMin
                      )}
                      id="infoSchlechtestePeriode"
                      infoText={"Periode mit der geringsten Entnahme."}
                    ></EstOutputLine> */}
                    <EstOutputLine
                      title="Durchschnittliches Endvermögen"
                      value={currencyFormatter(
                        results.withdrawal.realAvgEndSavings
                      )}
                      id="infoEndvermögen2"
                      infoText={"Die Obergrenze führt dazu, dass nicht mit Sicherheit das gesamte Vermögen verbraucht wird. \n Wählt man eine zu niedrige Obergrenze oder erwischt man eine Kapitalmarktphase mit vielen \n positiven Renditen verbleibt ein Erbe, da es dann keine schlechten Perioden gibt, in die der Konsum \n verschoben werden kann. "}
                    ></EstOutputLine>

                    <Text
                      style={{ width: "50%", ...spacing.sapUiContentPadding }}
                    >
                      Verteilung des Konsums pro Periode:
                    </Text>
                  </>
                )}
                { results.histData.length > 0 && (
                <ColumnChart
                  chartConfig={{
                  // yAxisConfig: { type: 'number', domain:[0, 0.5]},
                  //xAxisConfig: { label: { value:'Konsum'}},
                  }}
                  noLegend
                  dimensions={[{ accessor: "histId", interval: -1 }]}
                  measures={[
                    {
                      accessor: "histValue",
                      formatter: percentFormatter,
                      label: "Häufigkeitswahrscheinlichkeit",
                      stackId: "A",
                    },
                  ]}
                
                  dataset={results.histData}
                />
                )}

                <Table
                  columns={
                    <>
                      <TableColumn>
                        <Label>Quantil</Label>
                      </TableColumn>
                      <TableColumn>
                        <Label>
                          {selectedRule === "1"
                            ? "Reales Endvermögen"
                            : "Realer Konsum"}
                        </Label>
                      </TableColumn>
                    </>
                  }
                  style={{ width: "90%", ...spacing.sapUiContentPadding }}
                >
                  <TableRow>
                    <TableCell>
                      <Label>Bottom 5%</Label>
                    </TableCell>
                    <TableCell>
                      <Label>
                        {selectedRule === "1"
                          ? currencyFormatter(results.endSavings.endSavingsQ5)
                          : currencyFormatter(
                              results.withdrawal.realWithdrawalsQ5
                            )}
                      </Label>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Label>Bottom 25%</Label>
                    </TableCell>
                    <TableCell>
                      <Label>
                        {selectedRule === "1"
                          ? currencyFormatter(results.endSavings.endSavingsQ25)
                          : currencyFormatter(
                              results.withdrawal.realWithdrawalsQ25
                            )}
                      </Label>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Label>Top 50% (Median)</Label>
                    </TableCell>
                    <TableCell>
                      <Label>
                        {selectedRule === "1"
                          ? currencyFormatter(results.endSavings.endSavingsQ50)
                          : currencyFormatter(
                              results.withdrawal.realWithdrawalsQ50
                            )}
                      </Label>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Label>Top 25%</Label>
                    </TableCell>
                    <TableCell>
                      <Label>
                        {selectedRule === "1"
                          ? currencyFormatter(results.endSavings.endSavingsQ75)
                          : currencyFormatter(
                              results.withdrawal.realWithdrawalsQ75
                            )}
                      </Label>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Label>Top 5%</Label>
                    </TableCell>
                    <TableCell>
                      <Label>
                        {selectedRule === "1"
                          ? currencyFormatter(results.endSavings.endSavingsQ95)
                          : currencyFormatter(
                              results.withdrawal.realWithdrawalsQ95
                            )}
                      </Label>
                    </TableCell>
                  </TableRow>
                </Table>
                </Card>
                {selectedRule === "2" && (
                  <>
              <Card
                header={<CardHeader titleText="Zufälliger Konsumpfad" />}
                style={{ ...spacing.sapUiContentPadding }}
              >
                  <FlexBox
            style={{ width: "100%" , ...spacing.sapUiContentPadding  }}
            direction={FlexBoxDirection.Column}
            alignItems={FlexBoxAlignItems.Center}
          >
                <Button  icon={refresh} onClick={onRandomConsumeClick}>
                  Neuen zufälligen Konsumpfad anzeigen
                </Button>
                </FlexBox>
                <LineChart
                 chartConfig={{
                  yAxisConfig: { tickCount: 20, type: 'number', domain:[0,Math.floor(results.withdrawal.realWithdrawalsQ99)], label: { value: 'Konsum', angle: -90, position: 'insideLeft', offset:0 } },
                  xAxisConfig: { label: { value:'Jahre', position:'top', offset:-35}},
                  referenceLine: {  
                    color: 'red',
                    label: {position: 'top', value:'Durchschnitt über alle Simulationen'},
                    value: results.withdrawal.avgRealWithdrawal
                  }
                }}
                  noLegend
                  dimensions={[{ accessor: "year", interval: 1}]}
                  measures={[
                    {
                      hideDataLabel: true,
                      accessor: "value",
                      formatter: currencyFormatter,
                       label: "Konsum",
                    }
                  ]}
                  dataset={results.withdrawal.realWithdrawalsChartData[randomConsumeIndex]}
                />
                
                    
                      </Card>
                      </>
)}
            
            </FlexBox>
          )}
        </Panel>
      </Grid>
    </>
  );
}
